<div class="main-content">

  <!-- CARDS -->
  <div class="container">

    <div class="row">

      <div class="col-12 col-lg-6 col-xl-6">


        <div class="card">

          <div class="card-header">
            <h4 class="card-header-title">Passwort ändern</h4>
          </div>

          <div class="card-body">

            <div class="row">

              <div class="col-12">

                <!-- Password -->
                <div class="form-group">

                  <!-- Label -->
                  <label>
                    Passwort
                  </label>
                  <div class="input-group input-group-merge">
                    <!-- Input -->
                    <!--<input name="oldPassword" [(ngModel)]="oldPassword" type="password" class="form-control">-->
                    <input [type]="fieldTextType ? 'text' : 'password'"
                           name="oldPassword" [(ngModel)]="oldPassword" class="form-control form-control-appended">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="fa" [ngClass]="{
                              'fa-eye-slash': !fieldTextType,
                              'fa-eye': fieldTextType
                            }" (click)="toggleFieldTextType('CP')"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- New password -->
                <div class="form-group">

                  <!-- Label -->
                  <label>
                    Neues Passwort
                  </label>
                  <div class="input-group input-group-merge">
                    <!-- Input -->
                    <!--<input name="newPassword" [(ngModel)]="newPassword" type="password" class="form-control"
                           minlength="{{pwdMinLength}}" [pattern]="pwdPattern" #pwd="ngModel">-->

                    <input [type]="newPasswordTextType ? 'text' : 'password'"
                           name="newPassword" [(ngModel)]="newPassword" class="form-control form-control-appended">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="fa" [ngClass]="{
                             'fa-eye-slash': !newPasswordTextType,
                             'fa-eye': newPasswordTextType
                           }" (click)="toggleFieldTextType('NP')"></i>
                      </span>
                    </div>
                  </div>
                  
                  <!--<div *ngIf="pwd.errors" class="m-t-5">
                    <div class="alert alert-danger" *ngIf="(pwd.errors.minlength || pwd.errors.pattern)">
                      {{pwdErrorMsg}}
                    </div>
                  </div>-->
                </div>

                <!-- Confirm new password -->
                <div class="form-group">

                  <!-- Label -->
                  <label>
                    Neues Passwort bestätigen
                  </label>
                  <div class="input-group input-group-merge">
                    <!-- Input -->
                    <!--<input name="newPasswordRetype" [(ngModel)]="newPasswordRetype" type="password" class="form-control">-->

                    <input [type]="confirmPasswordTextType ? 'text' : 'password'"
                           name="newPasswordRetype" [(ngModel)]="newPasswordRetype" class="form-control form-control-appended">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="fa" [ngClass]="{
                              'fa-eye-slash': !confirmPasswordTextType,
                              'fa-eye': confirmPasswordTextType
                            }" (click)="toggleFieldTextType('COP')"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="alert alert-success" role="alert" [hidden]="!changePasswordSuccess">
                  <h4 class="alert-heading mb-0">Ihr Passwort wurde aktualisiert.</h4>
                </div>

                <div class="alert alert-danger" role="alert" [hidden]="!changePasswordError">
                  <h4 class="alert-heading mb-0">{{changePasswordError}}</h4>
                </div>

                <div class="text-right">

                  <!-- Submit -->
                  <button (click)="changePassword()" class="btn btn-primary" [disabled]="submitted">
                    {{submitted? 'Passwort wird aktualisiert' : 'Passwort aktualisieren' }}
                  </button>

                </div>

              </div>
            </div>
            <!-- / .row -->


          </div>
          <!-- / .card-body -->

        </div>
        <!-- / .card -->

      </div>
      <!-- <div class="col-12 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-body">
            <a class="nav-link" routerLink="/frame/documentation" target="_blank">
              <div class="btn btn-outline-primary">Zur Dokumenation</div>
            </a>
          </div>
        </div>
      </div> -->

    </div>


  </div>
  <!-- / .container -->

</div>
<!-- / .main-content -->
